import { render } from "./AllTransfers.vue?vue&type=template&id=42cb3dfc&scoped=true"
import script from "./AllTransfers.vue?vue&type=script&lang=js"
export * from "./AllTransfers.vue?vue&type=script&lang=js"

import "./AllTransfers.vue?vue&type=style&index=0&id=42cb3dfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cb3dfc"]])

export default __exports__